import { render, staticRenderFns } from "./Basic_Information.vue?vue&type=template&id=eaab8484&scoped=true&"
import script from "./Basic_Information.vue?vue&type=script&lang=js&"
export * from "./Basic_Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaab8484",
  null
  
)

export default component.exports